import { memo, type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import { LANGUAGE, type Language } from '@/shared/constants/language';

import ENLangIcon from '@/shared/assets/icons/en-lang.svg';
import ITLangIcon from '@/shared/assets/icons/it-lang.svg';

import cls from './language-switcher-item.module.css';

interface LanguageSwitcherItemProps {
    language: Language;
    isMenuItem?: boolean;
    additionSlot?: ReactNode;
    isAuth?: boolean;
}

export const LanguageSwitcherItem = memo((props: LanguageSwitcherItemProps) => {
    const {
        language,
        isMenuItem = false,
        isAuth = false,
        additionSlot,
    } = props;

    const { t } = useTranslation();

    const content = useMemo(
        () =>
            language === LANGUAGE.english ? (
                <>
                    <ENLangIcon />
                    <Typography.Text
                        className={cn({
                            [cls.text]: !isMenuItem,
                            [cls.auth]: isAuth,
                        })}
                    >
                        {t('english')}
                    </Typography.Text>
                </>
            ) : (
                <>
                    <ITLangIcon />
                    <Typography.Text
                        className={cn({
                            [cls.text]: !isMenuItem,
                            [cls.auth]: isAuth,
                        })}
                    >
                        {t('italian')}
                    </Typography.Text>
                </>
            ),
        [isAuth, isMenuItem, language, t],
    );

    return (
        <Flex
            align="center"
            className={cls.root}
            gap={8}
        >
            {content}
            {additionSlot}
        </Flex>
    );
});

LanguageSwitcherItem.displayName = 'LanguageSwitcherItem';
